import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateRegEdMyUserMap } from './useRegEdMyUserMapQuery';

export const useRegEdUserMapDeleteMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ impersonationContext }: { impersonationContext?: Api.IImpersonationContext } = {}) =>
			userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'compliance/regEd/userMap/me' }),
				'DELETE'
			),
		onError,
		onSuccess: () => {
			invalidateRegEdMyUserMap();
			onSuccess?.();
		},
	});
};
